import { v4 as uuidv4 } from "uuid";
import {
  CateringServiceRow,
  CateringServiceRowValues
} from "../Domain/Types/FacilityService-row.types";

/**
 * creates the newly created catering data and assembles a catering item object
 */
export function mapNewRowToPartialCateringItem(
  values: CateringServiceRowValues
): Partial<CateringServiceRow> {
  const newCateringItem = {
    uid: uuidv4(),
    id: values.id,
    name: values.name,
    pricePerUnit: values.pricePerUnit,
    description: values["description"],
    location: {
      id: values["location.id"],
      name: values["location.name"]
    },
    servicePermissions: values.servicePermissions,
    picturePath: values.picturePath
  };

  return newCateringItem;
}
